import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { appRoutes } from './app.routes';
import { authInterceptor } from './core/interceptor/auth.fn';
import { apiPrefixInterceptor } from './core/interceptor/api-prefix.fn';
import { AppModule } from './app.module';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes),
        provideHttpClient(
            withInterceptors([
                apiPrefixInterceptor,
                authInterceptor
            ])
        ),
        provideAnimations(),
        importProvidersFrom(AppModule)
    ]
};
